import { useContext } from 'react';
import { Autocomplete } from '@mantine/core';
import { BedethequeContext } from '../../utils/context/bedetheque';

/*
  Champ auteur réutilisable (grab + édition d'un album).
  Autocomplete branché sur la liste globale des auteurs : permet de réutiliser un
  auteur déjà en base ou d'en saisir un nouveau. Tous les props Mantine
  (value / defaultValue / onChange / onItemSubmit / rightSection / placeholder…)
  sont transmis tels quels — `data` et `icon` restent maîtrisés ici.
*/
function AuteurAutocomplete({ icon, ...props }) {
    const { auteurs } = useContext(BedethequeContext);
    const data = (auteurs || []).map((a) => ({ ...a, value: a.nom }));

    return <Autocomplete size="sm" {...props} icon={icon} data={data} />;
}

export default AuteurAutocomplete;
